module.exports = BD.Model.extend({
    reminder: BD.belongsTo('Billy.InvoiceReminder', { isParent: true }),
    invoice: BD.belongsTo('Billy.Invoice'),
    lateFee: BD.belongsTo('Billy.InvoiceLateFee')
})
